import { GiftService } from 'src/app/layout/gift-detail/services/gift-detail.service';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController, ToastController} from '@ionic/angular';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  @Input() data: any;
  @Input() typeGift: any;
  @Input() winnerStatus: any;
  @Input() manualRelease: boolean = false;
  @Input() campaignId: any;
  @Output() eventEmitter = new EventEmitter<any>();
  imageAsset = '../../../../../assets/images';
  @Input() typeCard: any;
  // tslint:disable-next-line:variable-name
  label_phone;
  isTimeGift = true;
  constructor(
      private modalController: ModalController,
      public toastCtrl: ToastController,
      private giftService: GiftService,
  ) { }
  ngOnInit() {
    console.log("manualRelease", this.manualRelease);
    if(this.manualRelease) { 
      this.winnerStatus = 'waiting_receive_gift'
    }
    
    console.log("winnerStatus", this.winnerStatus);
    // const phone = this.data.phone;
    // const length = phone.length;
    // const c = length % 3;
    // if (c) {
    //   const d = phone.slice(0, c);
    //   const d2 = phone.slice(c, length);
    //   let d3 = '';
    //   for (let i = 0; i < d2.length / 3; i++) {
    //     const p = d2.slice(3 * i, 3 * i + 3);
    //     d3 = d3 + ' ' + p;
    //   }
    //   this.label_phone = d + d3.slice(1, d3.length);
    // } else {
    //   let d = '';
    //   for (let i = 0; i < length / 3; i++) {
    //     const p = phone.slice(3 * i, 3 * i + 3);
    //     d = d + ' ' + p;
    //   }
    //   this.label_phone = d.slice(1, d.length);
    // }
    // this.label_phone = '+84 ' + this.label_phone.substring(1, this.label_phone.length);
  }
  retry() {
    this.eventEmitter.emit({
      step: 1
    });
  }

  closeModal(statusCode: number) {
    this.modalController.dismiss({statusCode});
  }

  async copyCard() {
    const textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.left = '0';
    textarea.style.top = '0';
    textarea.style.opacity = '0';
    textarea.value = this.data?.logPhonecard?.pin;
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    const toast = await this.toastCtrl.create({
      message: 'Sao chép mã thẻ thành công',
      duration: 1000
    });
    await toast.present();
  }

  isModalCard = false;
  getCard(num?) {
    return `tel://*${num || 100}*${this.data?.logPhonecard?.pin}${encodeURIComponent('#')}`;
  }
}
